'use client';
export default function BannerCTASection() {
  return (
    <section
      id="banner-7"
      className="relative overflow-hidden py-24"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=1600&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0" style={{ background: 'rgba(14,89,50,0.82)' }} />

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="max-w-xl">
          <h2
            className="text-4xl md:text-5xl font-black text-white mb-6"
            style={{ fontFamily: 'Lato, sans-serif' }}
          >
            Des Soins Médicaux de Haute Qualité, Accessibles à Tous
          </h2>
          <p className="text-white mb-8 leading-relaxed" style={{ opacity: 0.9 }}>
            COSA Ananeraie — Compagnie de Santé Africaine — vous offre un plateau technique de pointe et une qualité de soins dans un cadre soigné, pour élever les standards de santé en Côte d'Ivoire.
          </p>
          <a
            href="#"
            className="inline-block px-8 py-4 rounded font-bold text-sm uppercase tracking-wide transition-all"
            style={{ backgroundColor: '#fbaf45', color: '#fff', letterSpacing: '0.5px' }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#e89a2a')}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#fbaf45')}
          >
            Consultation Gratuite
          </a>
        </div>
      </div>
    </section>
  );
}
